class ComponentProductSizeChart extends HTMLElement {
  constructor() {
    super();
    this.btnSizes = this.querySelectorAll('.SizeChart__Block__Content--Options p');
    this.productTable = this.querySelector('.SizeChart__Block__Content--ProductTable');
    this.bodyTable = this.querySelector('.SizeChart__Block__Content--BodyTable');
    this.sectionProduct = document.querySelector('.product__form__wrapper');
    this.btnProductTable = this.querySelector('[data-target="product-table"]');
    this.btnBodyTable = this.querySelector('[data-target="product-body"]');
    this.productScale = this.querySelector('.Measure__Mark');
    this.productRuler = this.querySelector('.ScaleBlock__Measure');
    this.componentProductSizeChart = this.querySelector('.Product__SizeChart');
    this.sizeChartBlock = this.querySelector('.SizeChart__Block');
    this.btnProductSizechart = this.querySelector('.SizeChart__CTA__Btn');
    this.btnClose = this.querySelector('.SizeChart__Header__Hide');
    this.tableTds = this.querySelectorAll('.SizeChart__Block__Content table td');
    this.init();
  }

  async init() {
    if (this.sectionProduct) {
        this.sectionProduct.appendChild(this.componentProductSizeChart);
    }

    if (this.btnProductSizechart) {
        this.btnProductSizechart.addEventListener('click', () => {
            this.componentProductSizeChart.classList.add('SizeChart__Display');
            this.renderRuler();
        });
    }

    if (this.btnClose) {
        this.btnClose.addEventListener('click', () => {
            this.hide();
        });
    }

    if (this.componentProductSizeChart) {
        this.componentProductSizeChart.addEventListener('click', (e) => {
            if (!this.sizeChartBlock.contains(e.target)) {
                this.hide();
            }
        });
    }

    if (this.btnSizes) {
        this.btnSizes.forEach((btn) => {
            if (btn.dataset.target === 'product-table') {
                btn.classList.add('table-active');
            }

            btn.addEventListener('click', (e) => {
                if (e.target.dataset.target === 'product-table') {
                    if (!e.target.classList.contains('table-active')) {
                        e.target.classList.add('table-active');
                        this.btnBodyTable.classList.remove('table-active');
                    }

                    if (this.productTable && this.bodyTable) {
                        this.productTable.style.display = 'block';
                        this.bodyTable.style.display = 'none';
                    }
                }

                if (e.target.dataset.target === 'product-body') {
                    if (!e.target.classList.contains('table-active')) {
                        e.target.classList.add('table-active');
                        this.btnBodyTable.classList.remove('table-active');
                    }
                    this.btnBodyTable.classList.add('table-active');
                    this.btnProductTable.classList.remove('table-active');

                    if (this.productTable && this.bodyTable) {
                        this.productTable.style.display = 'none';
                        this.bodyTable.style.display = 'block';
                    }
                }
            })
        })
    }

    if (this.tableTds) {
        this.tableTds.forEach((td) => {
            td.addEventListener('mouseover', this.handleMouseover.bind(this));
            td.addEventListener('mouseout', this.handleMouseout.bind(this));
        })
    }

    if (this.productTable) {
        this.sortSizes();
    }
  }

  sortSizes() {
    const sortSizes = ['PP', 'P', 'M', 'G', 'GG', 'XGG'];
    const largeSizes = ['M', 'G', 'GG', 'XGG'];
    const firstSize = this.productTable.querySelector('tbody td') ? 
        this.productTable.querySelector('tbody td').textContent.toUpperCase() : '';

    if (largeSizes.includes(firstSize)) {
        const tbody = this.productTable.querySelector('tbody');
        const trs = Array.from(this.productTable.querySelectorAll('tbody tr'));
        trs.sort((a, b) => {
            const sizeA = a.children[0].textContent.trim().toUpperCase();
            const sizeB = b.children[0].textContent.trim().toUpperCase();
            return sortSizes.indexOf(sizeA) - sortSizes.indexOf(sizeB);
        });

        tbody.innerHTML = '';
        trs.forEach(tr => tbody.appendChild(tr));
    }
  }

  renderRuler() {
    if (this.productRuler && this.productScale) {
        const scale = this.productScale.dataset.scale ? +this.productScale.dataset.scale : 0;
        const rulerWidth = this.productRuler.offsetWidth;
        const position = (scale / 100) * rulerWidth;

        this.productScale.style.left = `${position}px`;
    }
  }

  hide() {
    this.componentProductSizeChart.classList.remove('SizeChart__Display');
  }

  handleMouseover(e) {
    const cell = e.target;
    const tr = cell.parentElement;
    const allRows = Array.from(this.sizeChartBlock.querySelectorAll("table tbody tr"));
    const rowIndex = allRows.indexOf(tr);
    const cellIndex = Array.from(tr.children).indexOf(cell);

    for (let i = 0; i <= rowIndex; i++) {
        const colCell = allRows[i].children[cellIndex];
        if (colCell) colCell.classList.add("Highlight__Col");
    }

    for (let i = 0; i <= cellIndex; i++) {
        const rowCell = tr.children[i];
        if (rowCell) rowCell.classList.add("Highlight__Row");
    }
  }

  handleMouseout(e) {
    const cell = e.target;
    const tr = cell.parentElement;
    const allRows = Array.from(this.sizeChartBlock.querySelectorAll("table tbody tr"));
    const rowIndex = allRows.indexOf(tr);
    const cellIndex = Array.from(tr.children).indexOf(cell);

    for (let i = 0; i <= rowIndex; i++) {
        const colCell = allRows[i].children[cellIndex];
        if (colCell) colCell.classList.remove("Highlight__Col");
    }

    for (let i = 0; i <= cellIndex; i++) {
        const rowCell = tr.children[i];
        if (rowCell) rowCell.classList.remove("Highlight__Row");
    }
  }
}

customElements.define("component-product-sizechart", ComponentProductSizeChart);
